import { PropsWithChildren, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { $tk } from 'utils/appTranslationKey';
import { PromotionFooterFC, PromotionFooterFCProps } from './PromotionFooterFC';

const useStrings = (): PromotionFooterFCProps['strings'] => {
  const intl = useIntl();

  return useMemo(
    () => ({
      moreDetails: intl.formatMessage({ id: $tk.components.PromotionFooter.moreDetails }),
      termsAndConditions: intl.formatMessage({
        id: $tk.components.PromotionFooter.termsAndConditionsLink,
      }),
      omnibusDisclaimer: intl.formatMessage({
        id: $tk.components.PromotionFooter.omnibusDisclaimerV2,
      }),
    }),
    [intl],
  );
};

export type PromotionFooterProps = PropsWithChildren<
  Omit<PromotionFooterFCProps, 'strings' | 'tacLink'>
>;

export function PromotionFooter(props: PromotionFooterProps) {
  const strings = useStrings();
  const url = 'https://food.bolt.eu/en-us/legal/';
  return <PromotionFooterFC {...props} strings={strings} tacLink={url} />;
}
